import { render, staticRenderFns } from "./MenuStockList.vue?vue&type=template&id=6154418a&scoped=true&"
var script = {}
import style0 from "./MenuStockList.vue?vue&type=style&index=0&id=6154418a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6154418a",
  null
  
)

export default component.exports